import examinationItem from './examinationItem.vue';

export default examinationItem;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/views/examination-item/index.ts